import React, { useEffect, useState } from "react";

import { API_BASE_URL } from "./config";
import { BRAND, getThemeColors } from "./themes";

export default function VerifyEmail({ theme }) {
  const [status, setStatus] = useState("verifying");
  const [msg, setMsg] = useState("");

  const themeColors = getThemeColors(theme);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const email = params.get("email");
    const token = params.get("token");

    if (!email || !token) {
      setStatus("error");
      setMsg("Missing email or token.");
      return;
    }

    fetch(`${API_BASE_URL}/verify_email?email=${encodeURIComponent(email)}&token=${encodeURIComponent(token)}`, {
      method: "GET",
    })
      .then(async (r) => {
        const data = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(data?.error || "Verification failed");
        return data;
      })
      .then((data) => {
        setStatus("ok");
        setMsg(data?.message || "Email verified!");
      })
      .catch((e) => {
        setStatus("error");
        setMsg(e.message);
      });
  }, []);

  return (
    <div style={{ 
      padding: 28, 
      background: themeColors.background, 
      minHeight: '100vh',
      fontFamily: BRAND.font
    }}>
      <img
        src="/logo_wordmark.png"
        alt="Loopen"
        style={{
          height: 48,
          width: 'auto',
          objectFit: 'contain',
          filter: theme === 'dark' ? 'invert(1) brightness(1.2)' : 'none',
          marginBottom: 8,
        }}
      />
      <div style={{ fontSize: 11, color: themeColors.textMuted, marginBottom: 24 }}>by Lausanne Business Solutions</div>

      <div style={{ maxWidth: 480 }}>
        <div style={{
          background: themeColors.cardBg,
          borderRadius: 10,
          padding: 32,
          border: `1px solid ${themeColors.borderColor}`,
        }}>
          {status === "verifying" && (
            <div style={{ fontSize: 18, fontWeight: 700, color: themeColors.text }}>
              Verifying…
            </div>
          )}

          {status === "ok" && (
            <>
              <div style={{ fontSize: 18, fontWeight: 700, color: themeColors.text, marginBottom: 12 }}>
                ✅ {msg}
              </div>
              <a href="/login"
                style={{
                  display: 'inline-block',
                  padding: '10px 14px',
                  borderRadius: 8,
                  background: themeColors.primary,
                  color: '#fff',
                  fontWeight: 600,
                  textDecoration: 'none',
                  fontSize: 14,
                }}
              >
                Go to Sign in
              </a>
            </>
          )}

          {status === "error" && (
            <div style={{ color: BRAND.error, fontSize: 14, fontWeight: 500 }}>
              {msg}
              <p style={{ marginTop: 12 }}>
                <a href="/login" style={{ color: themeColors.primary }}>Go to login</a>
              </p>
            </div>
          )}
        </div>
        <div style={{ fontSize: 12, color: themeColors.textMuted, marginTop: 16 }}>
          © {new Date().getFullYear()} Loopen
        </div>
      </div>
    </div>
  );
}